import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface CreateOTCPrescriptionParams {
  patientId: string;
  encounterId: string;
  carePlanId: string;
  freetextMedicationDetails: string;
}

interface CreateOTCPrescriptionResponse {
  bundle: object;
}

export const useCreateOTCPrescription = ({
  patientId,
  encounterId,
}: {
  patientId: string;
  encounterId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    CreateOTCPrescriptionResponse,
    CreateOTCPrescriptionParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.CREATE_OTC(
        patientId,
        encounterId,
      ),
      mutationFn: (params) => {
        return axiosInstance.post("/rx/prescriptions/otc", params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
